/**
 * Vendor Portal Service — Vendor dashboard, CRM, team, pricing, portfolio, subcontracts
 */
import api from './api';

const vendorPortalService = {
  // Subscription
  getMySubscription: () => api.get('/vendor-subscriptions/my').then(r => r.data),
  getPlans: () => api.get('/vendor-subscriptions/plans').then(r => r.data),
  subscribe: (data) => api.post('/vendor-subscriptions/subscribe', data).then(r => r.data),
  cancelSubscription: () => api.post('/vendor-subscriptions/cancel').then(r => r.data),

  // CRM
  getLeads: (params) => api.get('/vendor-crm/leads', { params }).then(r => r.data),
  createLead: (data) => api.post('/vendor-crm/leads', data).then(r => r.data),
  updateLead: (id, data) => api.put(`/vendor-crm/leads/${id}`, data).then(r => r.data),
  deleteLead: (id) => api.delete(`/vendor-crm/leads/${id}`).then(r => r.data),
  getPipeline: () => api.get('/vendor-crm/pipeline').then(r => r.data),
  getFollowUps: () => api.get('/vendor-crm/follow-ups').then(r => r.data),

  // Team
  getTeam: () => api.get('/vendor-team').then(r => r.data),
  addMember: (data) => api.post('/vendor-team', data).then(r => r.data),
  updateMember: (id, data) => api.put(`/vendor-team/${id}`, data).then(r => r.data),
  removeMember: (id) => api.delete(`/vendor-team/${id}`).then(r => r.data),

  // Pricing Rules
  getRules: () => api.get('/pricing-rules').then(r => r.data),
  createRule: (data) => api.post('/pricing-rules', data).then(r => r.data),
  updateRule: (id, data) => api.put(`/pricing-rules/${id}`, data).then(r => r.data),
  deleteRule: (id) => api.delete(`/pricing-rules/${id}`).then(r => r.data),
  calculatePrice: (data) => api.post('/pricing-rules/calculate', data).then(r => r.data),

  // Portfolio
  getProfile: () => api.get('/vendors/dashboard/profile').then(r => r.data),
  getPortfolioItems: () => api.get('/portfolio/my-items').then(r => r.data),
  getPortfolioItem: (id) => api.get(`/portfolio/${id}`).then(r => r.data),
  createPortfolioItem: (data) => api.post('/portfolio', data).then(r => r.data),
  updatePortfolioItem: (id, data) => api.put(`/portfolio/${id}`, data).then(r => r.data),
  deletePortfolioItem: (id) => api.delete(`/portfolio/${id}`).then(r => r.data),

  // Subcontracts
  getSubcontracts: () => api.get('/subcontracts').then(r => r.data),
  getMySubcontracts: () => api.get('/subcontracts/my').then(r => r.data),
  createSubcontract: (data) => api.post('/subcontracts', data).then(r => r.data),
  updateSubcontract: (id, data) => api.put(`/subcontracts/${id}`, data).then(r => r.data),
  acceptSubcontract: (id, data) => api.post(`/subcontracts/${id}/accept`, data).then(r => r.data)
};

export default vendorPortalService;
